namespace $.$$ {
	export class $bog_vmap_app_menu_item extends $.$bog_vmap_app_menu_item {

		override click( event?: Event ) {
			this.act( event )
			this.done( event )
			return null
		}

	}
}
